// extracted by mini-css-extract-plugin
export var standaloneTable = "_fb-0";
export var standaloneTableWithBodyFill = "_fb-1";
export var withExtraHeader = "_fb-2";